<template>
  <svg class="user-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_6206_1819)">
      <rect class="fill-color" width="20" height="20" fill="#2350AC" />
      <path
        d="M10 0.5C12.5196 0.5 14.9362 1.50063 16.7178 3.28223C18.4994 5.06382 19.5 7.48044 19.5 10C19.5 12.5196 18.4994 14.9362 16.7178 16.7178C14.9362 18.4994 12.5196 19.5 10 19.5C7.48044 19.5 5.06382 18.4994 3.28223 16.7178C1.50063 14.9362 0.5 12.5196 0.5 10C0.5 7.48044 1.50063 5.06382 3.28223 3.28223C5.06382 1.50063 7.48044 0.5 10 0.5Z"
        fill="white"
        stroke="white"
      />
      <path
        class="fill-color"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 10.7141C11.9725 10.7141 13.5715 9.11516 13.5715 7.14272C13.5715 5.17027 11.9725 3.57129 10.0001 3.57129C8.02766 3.57129 6.42867 5.17027 6.42867 7.14272C6.42867 9.11516 8.02766 10.7141 10.0001 10.7141ZM10 12.857C6.94717 12.857 4.30097 14.5981 3.00024 17.1414C4.80397 18.9096 7.27469 19.9999 10 19.9999C12.7254 19.9999 15.1961 18.9096 16.9998 17.1414C15.6991 14.5981 13.0529 12.857 10 12.857Z"
        fill="#2350AC"
      />
    </g>
    <defs>
      <clipPath id="clip0_6206_1819">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
.user-icon {
  .fill-color {
    transition: fill 300ms;
  }
}
</style>
